import React, { useState } from 'react';
import { TermsModal, PrivacyPolicyModal, RefundPolicyModal } from './LegalModals';

/* ═══════════════════════════════════════════════════════════
   LegalAcceptanceCheckbox
   • Self-contained: owns its own modal state
   • checked / onChange wired to parent (e.g., bank step)
   • Each doc name is a tappable link that opens its modal
═══════════════════════════════════════════════════════════ */
const LegalAcceptanceCheckbox = ({ checked, onChange }) => {
  const [modal, setModal] = useState(null); // 'terms' | 'privacy' | 'refund'

  const LinkBtn = ({ type, children }) => (
    <button
      type="button"
      onClick={() => setModal(type)}
      className="text-[#0A4D9D] font-bold underline underline-offset-2 hover:text-[#083d7e] transition-colors"
    >
      {children}
    </button>
  );

  return (
    <>
      <label
        className={`flex items-start gap-3.5 p-4 rounded-2xl border-2 cursor-pointer transition-all select-none ${
          checked
            ? 'bg-blue-50 border-blue-400'
            : 'bg-gray-50 border-gray-200 hover:border-blue-300'
        }`}
        dir="rtl"
      >
        {/* Custom checkbox */}
        <div className="flex-shrink-0 mt-[1px]">
          <input
            type="checkbox"
            className="sr-only"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          <div
            className={`w-5 h-5 rounded-md flex items-center justify-center transition-all ${
              checked
                ? 'bg-[#0A4D9D] border-[#0A4D9D]'
                : 'bg-white border-2 border-gray-300'
            }`}
          >
            {checked && (
              <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                <path d="M1 4L4 7.5L10 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </div>
        </div>

        {/* Text */}
        <p className="text-sm text-gray-700 leading-relaxed">
          أوافق على{' '}
          <LinkBtn type="terms">الشروط والأحكام</LinkBtn>
          {' '}و{' '}
          <LinkBtn type="privacy">سياسة الخصوصية</LinkBtn>
          {' '}و{' '}
          <LinkBtn type="refund">سياسة الإلغاء والاسترداد</LinkBtn>
          {' '}الخاصة بمنصة سافر.
        </p>
      </label>

      {/* Modals */}
      {modal === 'terms'   && <TermsModal   onClose={() => setModal(null)} />}
      {modal === 'privacy' && <PrivacyPolicyModal onClose={() => setModal(null)} />}
      {modal === 'refund'  && <RefundPolicyModal  onClose={() => setModal(null)} />}
    </>
  );
};

export default LegalAcceptanceCheckbox;
